import React from 'react';
import styles from './Notifications.module.scss';
import api from '../../../helpers/api';

import Loader from '../../miscellaneous/Loader/Loader';
import Tooltip from '../Tooltip/Tooltip';
import { $t } from '../../../helpers/translator';
import _ from "lodash";

import { IoAlertCircleOutline } from 'react-icons/io5';
import { IoWarningOutline } from 'react-icons/io5';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { IoTrashOutline } from 'react-icons/io5';
import { IoIosClose } from 'react-icons/io';
import {setAlert} from "../../../store/alerts-slice";
import {connect} from "react-redux";
import moment from "moment";

// import { ImEnlarge } from 'react-icons/im';
// import { ImShrink } from 'react-icons/im';
// import { ImEye } from 'react-icons/im';
// import { ImEyeBlocked } from 'react-icons/im';


class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: {
                all: [],
                unread: [],
                read: [],
                deleted: [],
            },
            nextPage: {
                all: 1,
                unread: 1,
                read: 1,
                deleted: 1,
            },
            unreadNotificationsCount: 0,
            selectedTab: 'all',
            expandedNotificationId: null,

            loading: true
        };
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        let res = await api.get('notification/count');
        this.setState({ unreadNotificationsCount: res.data });
        let page = this.state.nextPage[this.state.selectedTab];

        try {
            res = await api.get('notification?page=' + page);

            if (res.data.data) {
                let state = { ...this.state };

                // Adding page number to each new notification:
                let newNotifications = _.clone(res.data.data);
                _.forEach(newNotifications, (v) => {
                    v.page = state.nextPage[this.state.selectedTab];
                    state.notifications[this.state.selectedTab].push(v);
                });

                state.nextPage[this.state.selectedTab]++;
                //if this is last page, setting next page to negative:
                if (res.data.last_page < state.nextPage[this.state.selectedTab]) {
                    state.nextPage[this.state.selectedTab] = -1;
                }

                this.setState(state, () => {
                    this.setState({ loading: false });
                });
            }
        } catch (e) {
            console.error('err getting notifications.', e);
            this.setState({ loading: false });
        }
    }

    async loadMoreNotifications() {
        this.setState({ loading: true }, async () => {
            await this.init();
        });
    }

    selectTab(tab) {
        this.setState({ selectedTab: tab }, () => {
            // console.log(this.state)
        });
    }

    toggleNotificationExpand(id) {
        if (id === this.state.expandedNotificationId) {
            this.setState({ expandedNotificationId: null });
            return;
        }
        this.setState({ expandedNotificationId: id });
    }

    async trashBinClickHandler(notificationId, notificationKey) {
        let state = { ...this.state };
        let notification = state.notifications[this.state.selectedTab][notificationKey];
        state.notifications[this.state.selectedTab].splice(notificationKey, 1);
        state.notifications['deleted'].push(notification);
        state.unreadNotificationsCount = state.unreadNotificationsCount - 1;

        this.setState(state, async () => {
            //if deleted all visible notifications, and more are pending - loading more.
            if (!state.notifications[this.state.selectedTab] || !state.notifications[this.state.selectedTab].length) {
                let nextPage = {...this.state.nextPage}
                nextPage[this.state.selectedTab] = 1;
                this.setState({nextPage: nextPage}, async () => {
                    await this.loadMoreNotifications()
                })
            }
            this.emitNotificationsCount();

            try {
                await api.patch(`notification/changestatus/${notificationId}`, {});
                this.props.dispatch(setAlert({type: 'success'}));
            } catch (e) {
                console.error('err del', e);
                this.props.dispatch(setAlert({type: 'error'}));
            }
        });
    }

    emitNotificationsCount() {
        this.props.onNotificationsCountChange({
            count: this.state.unreadNotificationsCount
        });
    }

    emitCloseNotifications() {
        this.props.onClose({});
    }

    getNotificationColor(type) {
        switch (type) {
            case 'error':
                return '#EA5555';
            case 'warning':
                return '#eab855';
            default:
                return '#55aeea';
        }
    }

    getNotificationIcon(type) {
        switch (type) {
            case 'error':
                return <IoAlertCircleOutline/>;
            case 'warning':
                return <IoWarningOutline/>;
            default:
                return <IoInformationCircleOutline/>;
        }
    }

    async handleScroll(e) {
        let target = e.target;
        if (target.scrollHeight - target.scrollTop === target.clientHeight) {
            if (this.state.nextPage[this.state.selectedTab] >= 0) {
                await this.loadMoreNotifications();
            }
        }
    }

    getNotificationExpandedData(notification) {
        let fields = [
            {
                key: 'clinic_name',
                name: $t('global.notifications.clinic')
            },
            {
                key: 'machine_name',
                name: $t('global.notifications.machine')
            },
            {
                key: 'machine_id',
                name: $t('global.notifications.machineId')
            },
            {
                key: 'patient_id',
                name: $t('global.notifications.patientId')
            },
            {
                key: 'handle_name',
                name: $t('global.notifications.handle')
            },
            {
                key: 'handle_id',
                name: $t('global.notifications.handleId')
            },
            {
                key: 'skin_type_name',
                name: $t('global.notifications.skinType')
            },
            {
                key: 'area_name',
                name: $t('global.notifications.area')
            },
        ];

        return (
            <div className={`${styles['expanded-container']}`}>
                {fields.map((v, k) => (
                    <div className={`${styles['expanded-block']}`} key={k}>
                        <div className={`${styles['expanded-header']}`}>{v.name}</div>
                        <div className={`${styles['expanded-content']}`}>{(notification[v.key] ? notification[v.key] : 'N/A')}</div>
                    </div>
                ))}
            </div>
        );
    }

    renderNotification(notification, notificationKey) {
        notification.type = 'error';    //TODO: type should be supplied within notification

        let color = this.getNotificationColor(notification.type);
        let expanded = notification.id === this.state.expandedNotificationId;

        return (
            <div className={`${styles['notification-container']}`} key={notificationKey}
                 onClick={() => this.toggleNotificationExpand(notification.id)}>
                {/* style={{ borderColor: color }}*/}
                <div className={`${styles['notification-collapsed']}`}>
                    <div className={`${styles['icon']}`} style={{ color: color }}>
                        {this.getNotificationIcon(notification.type)}
                    </div>

                    <div className={`${styles['body']}`}>
                        <div className={`${styles['header']}`} style={{ color: color }}>
                            {notification.error_name} ({notification.id})
                        </div>
                        <div className={`${styles['date']}`}>
                            {notification.created_at !== null && moment(notification.created_at).fromNow()}
                        </div>
                        <div className={`${styles['text']} ${styles[(expanded ? 'text-expanded' : '')]}`}>
                            {/*{notification.content} **/}
                            {$t('global.notifications.machine')}: {notification.machine_name}. {$t('global.notifications.clinic')}: {notification.clinic_name}.
                        </div>
                    </div>

                    <div className={`${styles['actions']}`}>
                        <div className={`${styles['top']}`}>
                            <Tooltip content={$t('global.general.delete')}>
                                <div className={`${styles['icon-small']}`}><IoTrashOutline
                                    onClick={() => this.trashBinClickHandler(notification.id, notificationKey)}/></div>
                            </Tooltip>
                        </div>
                    </div>
                </div>

                <div className={`${styles['notification-info']} ${styles[(expanded ? '' : 'notification-info--hidden')]}`}>
                    <div className={`${styles['inner-notification-info']}`}>
                        {this.getNotificationExpandedData(notification)}
                    </div>
                </div>
            </div>
        );
    }

    renderTabsRow() {
        return (
            <div className={`${styles['tabs-row']}`}>
                <div
                     className={`${styles['tab-header']} ${styles[(this.state.selectedTab === 'all' ? 'tab-selected' : '')]}`}
                     onClick={() => this.selectTab('all')}>All
                </div>
                <div
                     className={`${styles['tab-header']} ${styles[(this.state.selectedTab === 'unread' ? 'tab-selected' : '')]}`}
                     onClick={() => this.selectTab('unread')}>Unread
                </div>
                <div
                     className={`${styles['tab-header']} ${styles[(this.state.selectedTab === 'read' ? 'tab-selected' : '')]}`}
                     onClick={() => this.selectTab('read')}>Read
                </div>
                <div
                     className={`${styles['tab-header']} ${styles[(this.state.selectedTab === 'deleted' ? 'tab-selected' : '')]}`}
                     onClick={() => this.selectTab('deleted')}>Deleted
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className={`${styles['screen-overlay']}`} onClick={() => this.emitCloseNotifications()}>
                <div className={`${styles['container']}`}>
                    <div className={`${styles['header-row']}`}>
                        <div>{$t('global.menu.notifications')}</div>
                        <IoIosClose style={{
                            fontSize: '35px',
                            cursor: 'pointer'
                        }} onClick={() => this.emitCloseNotifications()}/>
                    </div>
                    {/*{ this.renderTabsRow() }*/}
                    <div className={`${styles['notifications-container']}`} onScroll={this.handleScroll.bind(this)} onClick={(e) => {
                        e.stopPropagation();
                    }}>
                        {this.state.notifications[this.state.selectedTab] &&
                        <div>
                            {this.state.notifications[this.state.selectedTab].map((notification, k) => (
                                this.renderNotification(notification, k)
                            ))}
                        </div>
                        }

                        <div className={`${styles['load-more-container']}`}>
                            {this.state.loading ?
                                <div className={`${styles['load-more-container']}`}>
                                    <Loader
                                        type="ThreeDots"
                                        color="#1f1f1f"
                                    />
                                </div>
                                :
                                <div>
                                    {this.state.nextPage[this.state.selectedTab] >= 0 ?
                                        <div className={`${styles['load-more-container']} ${styles['more']}`}
                                             onClick={() => this.loadMoreNotifications()}>
                                            {$t('global.notifications.moreNotificationsPending')}
                                        </div>
                                        :
                                        <div className={`${styles['load-more-container']}`}>
                                            {$t('global.notifications.noMoreNotifications')}
                                        </div>
                                    }
                                </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// export default Notifications;

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(Notifications);
